import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import IndexSection from "@/pages/home/components/IndexSection";
import ProfileSection from "@/pages/home/components/ProfileSection";
import HighlightsSection from "@/pages/home/components/HighlightsSection";
import GallerySection from "@/pages/home/components/GallerySection";
import ResourceSection from "@/pages/home/components/ResourceSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <IndexSection />
        <ProfileSection />
        <HighlightsSection />
        <GallerySection />
        <ResourceSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}